import React from 'react';

import { SVGComponentProps } from './svg.types';

const SubtaskSVG = ({
  fill = 'currentColor',
  size = '1em',
  wrapperClass,
  ...otherProps
}: SVGComponentProps) => {
  return (
    <span className={`inline-block ${wrapperClass || ''}`}>
      <svg
        width={size}
        height={size}
        viewBox="0 0 20 20"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        {...otherProps}
      >
        <path
          d="M5.83329 7.29163H3.33329C2.06663 7.29163 1.04163 6.26663 1.04163 4.99996V3.33329C1.04163 2.06663 2.06663 1.04163 3.33329 1.04163H5.83329C7.09996 1.04163 8.12496 2.06663 8.12496 3.33329V4.99996C8.12496 6.26663 7.09996 7.29163 5.83329 7.29163ZM3.33329 2.29163C2.75829 2.29163 2.29163 2.75829 2.29163 3.33329V4.99996C2.29163 5.57496 2.75829 6.04163 3.33329 6.04163H5.83329C6.40829 6.04163 6.87496 5.57496 6.87496 4.99996V3.33329C6.87496 2.75829 6.40829 2.29163 5.83329 2.29163H3.33329Z"
          fill={fill}
        />
        <path
          d="M17.3334 6.45833H14.3334C13.4334 6.45833 12.7084 5.72499 12.7084 4.83332V3.50001C12.7084 2.60001 13.4417 1.875 14.3334 1.875H17.3334C18.2334 1.875 18.9584 2.60834 18.9584 3.50001V4.83332C18.9584 5.73332 18.2334 6.45833 17.3334 6.45833ZM14.3334 3.125C14.1334 3.125 13.9584 3.30001 13.9584 3.50001V4.83332C13.9584 5.03332 14.1334 5.20833 14.3334 5.20833H17.3334C17.5334 5.20833 17.7084 5.03332 17.7084 4.83332V3.50001C17.7084 3.30001 17.5334 3.125 17.3334 3.125H14.3334Z"
          fill={fill}
        />
        <path
          d="M17.3334 12.7083H14.3334C13.4334 12.7083 12.7084 11.975 12.7084 11.0833V9.75001C12.7084 8.85001 13.4417 8.125 14.3334 8.125H17.3334C18.2334 8.125 18.9584 8.85834 18.9584 9.75001V11.0833C18.9584 11.9833 18.2334 12.7083 17.3334 12.7083ZM14.3334 9.375C14.1334 9.375 13.9584 9.55001 13.9584 9.75001V11.0833C13.9584 11.2833 14.1334 11.4583 14.3334 11.4583H17.3334C17.5334 11.4583 17.7084 11.2833 17.7084 11.0833V9.75001C17.7084 9.55001 17.5334 9.375 17.3334 9.375H14.3334Z"
          fill={fill}
        />
        <path
          d="M13.3333 4.79163H7.5C7.15833 4.79163 6.875 4.50829 6.875 4.16663C6.875 3.82496 7.15833 3.54163 7.5 3.54163H13.3333C13.675 3.54163 13.9583 3.82496 13.9583 4.16663C13.9583 4.50829 13.675 4.79163 13.3333 4.79163Z"
          fill={fill}
        />
        <path
          d="M13.3333 17.2916H12.0833C10.8166 17.2916 9.79163 16.2666 9.79163 15V4.16663C9.79163 3.82496 10.075 3.54163 10.4166 3.54163C10.7583 3.54163 11.0416 3.82496 11.0416 4.16663V15C11.0416 15.575 11.5083 16.0416 12.0833 16.0416H13.3333C13.675 16.0416 13.9583 16.325 13.9583 16.6666C13.9583 17.0083 13.675 17.2916 13.3333 17.2916Z"
          fill={fill}
        />
        <path
          d="M13.3333 11.0416H10.4166C10.075 11.0416 9.79163 10.7583 9.79163 10.4166C9.79163 10.075 10.075 9.79163 10.4166 9.79163H13.3333C13.675 9.79163 13.9583 10.075 13.9583 10.4166C13.9583 10.7583 13.675 11.0416 13.3333 11.0416Z"
          fill={fill}
        />
        <path
          d="M17.3334 18.9583H14.3334C13.4334 18.9583 12.7084 18.225 12.7084 17.3333V16C12.7084 15.1 13.4417 14.375 14.3334 14.375H17.3334C18.2334 14.375 18.9584 15.1083 18.9584 16V17.3333C18.9584 18.2333 18.2334 18.9583 17.3334 18.9583ZM14.3334 15.625C14.1334 15.625 13.9584 15.8 13.9584 16V17.3333C13.9584 17.5333 14.1334 17.7083 14.3334 17.7083H17.3334C17.5334 17.7083 17.7084 17.5333 17.7084 17.3333V16C17.7084 15.8 17.5334 15.625 17.3334 15.625H14.3334Z"
          fill={fill}
        />
      </svg>
    </span>
  );
};

export default SubtaskSVG;
